import { createShouldForwardPropBlockList } from "@components/common/utils/helper";
import styled from "styled-components";

type ToggleProps = { open: boolean };

export const Wrapper = styled("ul")(() => ({
    position: "relative",
}));

export const ListItem = styled("li")(() => ({
    position: "relative",
    "&:hover": {
        [`${Submenu}`]: {
            opacity: 1,
            pointerEvents: "auto",
        },
    },
}));

export const Toggle = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["open"]),
})<ToggleProps>(({ open, theme }) => ({
    rotate: open ? "270deg" : "90deg",
    transform: "scale(.8)",
    transitionProperty: "rotate",
    transitionDuration: "200ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
}));

export const Submenu = styled("ul")(({ theme }) => ({
    height: "0px",
    overflow: "hidden",
    transitionProperty: "height",
    transitionDuration: "200ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
}));

export const ChildListItem = styled("li")(({ theme }) => ({
    transform: "translateY(-50px)",
    transitionProperty: "transform",
    transitionDuration: "200ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
}));
